module.exports = __webpack_public_path__ + "img/couponDoctor_a.4ae975c7.png";